import { DatabaseSchema, Pooja, GalleryItem, SiteConfig, Banner } from './types';

export const DEFAULT_CONFIG: SiteConfig = {
  templeName: "Arunoottimangalam Bhagavathy Temple",
  templeNameMal: "അറുനൂറ്റിമംഗലം ഭഗവതി ക്ഷേത്രം",
  phone: "+91 9496942062",
  email: "contact@arunoottimangalam.com",
  address: "Arunoottimangalam, Kerala, India - 686604",
  addressMal: "അറുനൂറ്റിമംഗലം പി.ഒ, കടുത്തുരുത്തി ,കോട്ടയം, കേരള -686604",
  upiId: "temple@upi",
  whatsappNumber: "9496942062",
  announcements: [
    "Annual Thalappoli Mahotsavam starts on April 14th.",
    "Special Poojas available for booking during Vishu.",
  ],
  announcementsMal: [
    "പ്രതിഷ്ഠാ വാർഷിക മഹോത്സവം 2026 മാർച്ച് 27 ,28, 29 ദിവസങ്ങളിൽ",
    "ഭഗവതിക്കായ് ഒരുപിടി മണ്ണ് എന്ന ഉദ്യമത്തിലേക്ക് ഉദാരമായി  സംഭാവന നൽകുക "
  ],
  homeAboutTitle: "A Sacred Spiritual Center",
  homeAboutTitleMal: "പുണ്യമായ ആത്മീയ കേന്ദ്രം",
  homeAboutText: "Arunoottimangalam Bhagavathy Temple is an ancient Hindu temple situated in Kerala. The presiding deity is Goddess Bhadrakali, worshipped as the mother of the universe. Devotees from far and wide visit to seek her blessings for prosperity, health, and protection.",
  homeAboutTextMal: "കേരളത്തിൽ സ്ഥിതി ചെയ്യുന്ന പുരാതനമായ ക്ഷേത്രമാണ് അരുനൂട്ടിമംഗലം ഭഗവതി ക്ഷേത്രം. പ്രപഞ്ചനാഥയായ ഭദ്രകാളി ദേവിയാണ് ഇവിടുത്തെ പ്രധാന പ്രതിഷ്ഠ. ഐശ്വര്യത്തിനും ആരോഗ്യത്തിനും സംരക്ഷണത്തിനായി ദൂരദേശങ്ങളിൽ നിന്ന് പോലും ഭക്തർ ഇവിടെ എത്തിച്ചേരുന്നു.",
  // Priests
  thantriName: "Thantri Name",
  thantriImageUrl: "/images/thantri.jpg",
  pujariName: "Pujari Name",
  pujariImageUrl: "/images/pujari.jpg",
  // Social links
  facebookUrl: "https://facebook.com/",
  youtubeUrl: "https://youtube.com/",
  // About page content
  aboutTitle: "History & Significance",
  aboutTitleMal: "ചരിത്രവും പ്രാധാന്യവും",
  aboutContent: "The Arunoottimangalam Bhagavathy Temple stands as a testament to the rich spiritual heritage of Kerala. Believed to be centuries old, the temple is dedicated to Goddess Bhadrakali, the fierce yet compassionate mother goddess who protects her devotees from all evils.",
  aboutContentMal: "കേരളത്തിന്റെ സമ്പന്നമായ ആത്മീയ പൈതൃകത്തിന്റെ തെളിവായി അരുനൂട്ടിമംഗലം ഭഗവതി ക്ഷേത്രം നിലകൊള്ളുന്നു. നൂറ്റാണ്ടുകൾ പഴക്കമുള്ളതായി കരുതപ്പെടുന്ന ഈ ക്ഷേത്രം ഭദ്രകാളി ദേവിക്ക് സമർപ്പിച്ചതാണ്. ഭക്തരെ ദുരിതങ്ങളിൽ നിന്ന് കാത്തുസൂക്ഷിക്കുന്ന കരുണാമയിയായ ദേവിയാണ് ഭദ്രകാളി.",
  homeMediaVolume: 0.8
};

export const DEFAULT_POOJAS: Pooja[] = [
  {
    id: "1",
    name: "Pushpanjali",
    nameMal: "പുഷ്പാഞ്ജലി",
    description: "Offering of flowers to the deity for blessings and well-being.",
    descriptionMal: "ദോഷങ്ങൾ അകറ്റുന്നതിനും ഐശ്വര്യത്തിനും വേണ്ടി പുഷ്പങ്ങൾ അർപ്പിക്കുന്നു.",
    price: 20,
    timing: "Morning: 5:30 AM - 9:30 AM",
    timingMal: "രാവിലെ 5:30 - 9:30 വരെ"
  },
  {
    id: "2",
    name: "Rakta Pushpanjali",
    nameMal: "രക്ത പുഷ്പാഞ്ജലി",
    description: "Special offering for removing obstacles and enemies (dosha pariharam).",
    descriptionMal: "ശത്രുദോഷം, തടസ്സങ്ങൾ എന്നിവ നീക്കുന്നതിനുള്ള പ്രത്യേക വഴിപാട്.",
    price: 30,
    timing: "Morning & Evening",
    timingMal: "രാവിലെയും വൈകുന്നേരവും"
  },
  {
    id: "3",
    name: "Ganapathy Homam",
    nameMal: "ഗണപതി ഹോമം",
    description: "Fire ritual dedicated to Lord Ganesha for new beginnings.",
    descriptionMal: "വിഘ്നങ്ങൾ മാറുന്നതിനായി ഗണപതി ഭഗവാന് സമർപ്പിക്കുന്ന ഹോമം.",
    price: 500,
    timing: "Morning: 6:00 AM",
    timingMal: "രാവിലെ 6:00-ന്"
  },
  {
    id: "4",
    name: "Bhagavathy Seva",
    nameMal: "ഭഗവതി സേവ",
    description: "Elaborate evening pooja dedicated to the Goddess.",
    descriptionMal: "ദേവി പ്രീതിക്കായി വൈകുന്നേരങ്ങളിൽ നടത്തുന്ന വിശേഷാൽ പൂജ.",
    price: 1500,
    timing: "Evening: 6:30 PM",
    timingMal: "വൈകുന്നേരം 6:30-ന്"
  },
  {
    id: "5",
    name: "Chuttuvilakku",
    nameMal: "ചുറ്റുവിളക്ക്",
    description: "Lighting lamps around the temple for prosperity.",
    descriptionMal: "ക്ഷേത്രത്തിന് ചുറ്റും ദീപങ്ങൾ തെളിയിക്കുന്ന വഴിപാട്.",
    price: 2000,
    timing: "Evening: 6:45 PM",
    timingMal: "വൈകുന്നേരം 6:45-ന്"
  }
];

export const DEFAULT_GALLERY: GalleryItem[] = [
  { id: "1", url: "/images/gallery-1.jpg", caption: "Temple Entrance", captionMal: "ക്ഷേത്ര കവാടം" },
  { id: "2", url: "/images/gallery-2.jpg", caption: "Deeparadhana", captionMal: "ദീപാരാധന" },
  { id: "3", url: "/images/gallery-3.jpg", caption: "Festival Crowd", captionMal: "ഉത്സവ ജനക്കൂട്ടം" },
  { id: "4", url: "/images/gallery-4.jpg", caption: "Elephants at Festival", captionMal: "എഴുന്നള്ളിപ്പ്" },
  { id: "5", url: "/images/gallery-5.jpg", caption: "Nirmalyam", captionMal: "നിർമ്മാല്യം" },
  { id: "6", url: "/images/gallery-6.jpg", caption: "Temple Pond", captionMal: "ക്ഷേത്ര കുളം" },
];

export const DEFAULT_BANNERS: Banner[] = [
  {
    id: "1",
    imageUrl: "/images/v2.jpg",
    title: "Arunoottimangalam Bhagavathy Temple",
    titleMal: "അറുനൂറ്റിമംഗലം ഭഗവതി ക്ഷേത്രം",    
    subtitleMal: "അറുനൂറ്റിമംഗലം ഭഗവതി ക്ഷേത്രം" 
  }
];

export const INITIAL_DB: DatabaseSchema = {
  config: DEFAULT_CONFIG,
  poojas: DEFAULT_POOJAS,
  gallery: DEFAULT_GALLERY,
  banners: DEFAULT_BANNERS
};
